import {HeadersHandler} from "./headers-handler";

export class ArticlesHeadersHandler extends HeadersHandler {

    constructor() {
        super();
    }

    getHeaders() {
        const self = this;
        const headers = {};
        let column = {
            value: 0
        };

        const customIdHeader = super.getCustomId(column.value, "Custom ID");
        Object.assign(headers, customIdHeader.headers);
        column.value = column.value + customIdHeader.count;

        const diffbotUriHeader = super.getDiffbotUri(column.value);
        Object.assign(headers, diffbotUriHeader.headers);
        column.value = column.value + diffbotUriHeader.count;

        const articleHeadersMethods = $("#articleOutputConfigTable tr[headers-method]");
        articleHeadersMethods.each(function () {
            const method = $(this).attr("headers-method");
            self[method](headers, column);
        });

        return {
            headers: headers,
            count: column.value
        }
    }

    getTags(column, format, resultsLimit, withSentiments) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["tags"] = {
            data: [],
            autofitColumns: true
        };
        if (format === "Multiple Columns") {
            output.headers["tags"].type = "multipleColumns";
            for (let i = 1; i <= resultsLimit; i++) {
                output.headers["tags"].data.push([]);
                const lastIndex = output.headers["tags"].data.length - 1;
                output.headers["tags"].data[lastIndex].push({
                    value: "Tag " + i + " - Label",
                    column: column
                });
                output.count++;
                column++;
                output.headers["tags"].data[lastIndex].push({
                    value: "Tag " + i + " - Count",
                    column: column
                });
                output.count++;
                column++;
                output.headers["tags"].data[lastIndex].push({
                    value: "Tag " + i + " - Score",
                    column: column
                });
                output.count++;
                column++;
                output.headers["tags"].data[lastIndex].push({
                    value: "Tag " + i + " - Diffbot URL",
                    column: column
                });
                output.count++;
                column++;
                if (withSentiments) {
                    output.headers["tags"].data[lastIndex].push({
                        value: "Tag " + i + " - Sentiment",
                        column: column
                    });
                    output.count++;
                    column++;
                }
            }
        }
        if (format === "Multiple Rows") {
            output.headers["tags"].type = "multipleRows";
            output.headers["tags"].data.push({
                value: "Tag - Label",
                column: column
            });
            output.count++;
            column++;
            output.headers["tags"].data.push({
                value: "Tag - Count",
                column: column
            });
            output.count++;
            column++;
            output.headers["tags"].data.push({
                value: "Tag - Score",
                column: column
            });
            output.count++;
            column++;
            output.headers["tags"].data.push({
                value: "Tag - Diffbot URL",
                column: column
            });
            output.count++;
            column++;
            if (withSentiments) {
                output.headers["tags"].data.push({
                    value: "Tag - Sentiment",
                    column: column
                });
                output.count++;
                column++;
            }
        }
        return output;
    }

    getQuotes(column, format, resultsLimit) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["quotes"] = {
            data: [],
            autofitColumns: true
        };
        if (format === "Multiple Columns") {
            output.headers["quotes"].type = "multipleColumns";
            for (let i = 1; i <= resultsLimit; i++) {
                output.headers["quotes"].data.push([]);
                const lastIndex = output.headers["quotes"].data.length - 1;
                output.headers["quotes"].data[lastIndex].push({
                    value: "Quote " + i,
                    column: column
                });
                output.count++;
                column++;
                output.headers["quotes"].data[lastIndex].push({
                    value: "Quote " + i + " - Speaker",
                    column: column
                });
                output.count++;
                column++;
                output.headers["quotes"].data[lastIndex].push({
                    value: "Quote " + i + " - Speaker's Diffbot URL",
                    column: column
                });
                output.count++;
                column++;
            }
        }
        if (format === "Multiple Rows") {
            output.headers["quotes"].type = "multipleRows";
            output.headers["quotes"].data.push({
                value: "Quote",
                column: column
            });
            output.count++;
            column++;
            output.headers["quotes"].data.push({
                value: "Quote - Speaker",
                column: column
            });
            output.count++;
            column++;
            output.headers["quotes"].data.push({
                value: "Quote - Speaker's Diffbot URL",
                column: column
            });
            output.count++;
            column++;
        }
        return output;
    }

    setArticleWebsite(headers, column) {
        if ($("#articleWebsiteInformationOutputCheckbox").is(":checked")) {
            headers["siteName"] = {
                type: "normal",
                autofitColumns: true,
                data: [{
                    value: "Website",
                    column: column.value
                }]
            };
            column.value++;

            const pageUrlHeader = super.getPageUrl(column.value);
            Object.assign(headers, pageUrlHeader.headers);
            column.value = column.value + pageUrlHeader.count;
        }
    }

    setArticleAuthor(headers, column) {
        if ($("#articleAuthorInformationOutputCheckbox").is(":checked")) {
            headers["author"] = {
                type: "normal",
                autofitColumns: true,
                data: [{
                    value: "Author",
                    column: column.value
                }]
            };
            column.value++;
            headers["authorUrl"] = {
                type: "normal",
                autofitColumns: true,
                data: [{
                    value: "Author URL",
                    column: column.value
                }]
            };
            column.value++;
        }
    }

    setArticleTitle(headers, column) {
        if ($("#articleTitleOutputCheckbox").is(":checked")) {
            const titleHeader = super.getTitle(column.value);
            Object.assign(headers, titleHeader.headers);
            column.value = column.value + titleHeader.count;
        }
    }

    setArticleDates(headers, column) {
        if ($("#articleDatesInformationOutputCheckbox").is(":checked")) {
            headers["estimatedDate"] = {
                type: "special",
                autofitColumns: false,
                data: [{
                    value: "Date",
                    column: column.value
                }]
            };
            column.value++;
            headers["lastCrawlTime"] = {
                type: "special",
                autofitColumns: false,
                data: [{
                    value: "Last Crawl Time",
                    column: column.value
                }]
            };
            column.value++;
        }

    }

    setArticlePublisher(headers, column) {
        if ($("#articlePublisherInformationOutputCheckbox").is(":checked")) {
            headers["publisherRegion"] = {
                type: "normal",
                autofitColumns: true,
                data: [{
                    value: "Publisher Region",
                    column: column.value
                }]
            };
            column.value++;
            headers["publisherCountry"] = {
                type: "normal",
                autofitColumns: true,
                data: [{
                    value: "Publisher Country",
                    column: column.value
                }]
            };
            column.value++;
        }
    }

    setArticleLanguage(headers, column) {
        if ($("#articleLanguageOutputCheckbox").is(":checked")) {
            headers["language"] = {
                type: "normal",
                autofitColumns: true,
                data: [{
                    value: "language",
                    column: column.value
                }]
            };
            column.value++;
        }
    }

    setArticleTags(headers, column) {
        const self = this;
        if ($("#articleTagsOutputCheckbox").is(":checked")) {
            const format = $('#articleTagsFormat :selected').text();
            const resultsLimit = $("#articleTagsLimit").val();
            const withSentiments = $("#articleSentimentsOutputCheckbox").is(":checked");
            const tags = self.getTags(column.value, format, resultsLimit, withSentiments);
            Object.assign(headers, tags.headers);
            column.value = column.value + tags.count;
        }
    }

    setArticleQuotes(headers, column) {
        const self = this;
        if ($("#articleQuotesOutputCheckbox").is(":checked")) {
            const format = $('#articleQuotesFormat :selected').text();
            const resultsLimit = $("#articleQuotesLimit").val();
            const quotes = self.getQuotes(column.value, format, resultsLimit);
            Object.assign(headers, quotes.headers);
            column.value = column.value + quotes.count;
        }

    }
}